import { ReactNode } from 'react'

import { type Offer, OffersProviderContext } from './offers-provider-context.js'

type OfferProviderProps = {
  offers: Offer[]
  children: ReactNode
}

export const OffersProvider = ({ offers, children }: OfferProviderProps) => {
  return <OffersProviderContext.Provider value={{ offers }}>{children}</OffersProviderContext.Provider>
}
